import { InformationCard } from '@design-system';
import { useTranslation } from 'next-i18next';

type PreOrderOpportunityBannerProps = {
  images: {
    src: string;
    alt: string;
  }[];
};

const previewImages = (images: PreOrderOpportunityBannerProps['images']) => {
  const [first, second] = images;
  if (!first) {
    return undefined;
  }
  if (!second) {
    return [first] as [{ src: string; alt: string }];
  }
  return [first, second] as [
    { src: string; alt: string },
    { src: string; alt: string },
  ];
};

export const PreOrderOpportunityBanner = ({
  images,
}: PreOrderOpportunityBannerProps) => {
  const { t } = useTranslation('checkout');

  return (
    <InformationCard
      images={previewImages(images)}
      pill={{
        text: t('orderReview.preOrderBanner.badge'),
        className: 'bg-verified-2',
        textClassName: 'text-verified-6',
      }}
      text={t('orderReview.preOrderBanner.description')}
    />
  );
};
